export const GoToTopAnchor = () => {
    return <div id="toppen"></div>;
};

export default GoToTopAnchor;
